<template>
  <div class="flex justify-center mb-8 mt-[50px]">
    <h2 class="text-[28px] font-bold">
      {{ t("signup.createAccount") }}
    </h2>
  </div>
  <div v-if="isState('emailInput') || isState('emailVerify')">
    <SignupEmailInput
      v-if="isState('emailInput')"
      v-model:email="email"
      @start-verification="
        () => {
          emailError = '';
          transition('emailVerify');
        }
      "
      @start-verification-with-error="
        (errorMessage) => {
          emailError = errorMessage;
          transition('emailVerify');
          console.log('index error ', errorMessage);
        }
      "
    />

    <SignupVerifyEmail
      v-if="isState('emailVerify')"
      :email="email"
      :email-error="emailError"
      v-model:emailVerify="tempEmailVerify"
      v-model:emailToken="emailToken"
      @cancel="handleCancel"
      @verified="(token) => handleVerified(token)"
    />
  </div>

  <SignupCreateAccount
    v-else-if="isState('createAccount') && emailToken"
    :emailValue="email"
    :emailToken="emailToken"
  />
  <div v-if="isState('emailInput')">
    <p class="text-[#666666] mt-5 text-center">
      {{ t("signup.alreadyHaveAccount") }}
      <span class="text-[#9FA2FB] font-bold track">
        <a :href="`${config.public.GSNurl}/`">
          {{ t("signup.Login") }}
        </a>
      </span>
    </p>
    <div class="flex  gap-4 leading-none text-colorGrey5 justify-center mt-8">
      <a
        :href="`${config.public.TermsOfServiceUrl}`"
        target="_blank"
        class="text-white underline hover:underline"
        >{{ t("signup.TermsOfService") }}</a
      >
  
      <a
        :href="`${config.public.PrivacyUrl}`"
        target="_blank"
        class="text-white underline hover:underline"
        >{{ t("signup.privacyPolicy") }}</a
      >
    </div>
  </div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: "auth",
});

import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { currentState, transition, isState } = useSignupStateMachine();
const email = ref<string>("");
const emailToken = ref<string>("");
const tempEmailVerify = ref(false);
const config = useRuntimeConfig();
const emailError = ref<string>("");

const handleVerified = (token: string) => {
  emailToken.value = token;
  transition("createAccount");
};

const handleCancel = () => {
  // 清空 email
  email.value = "";

  // 轉換狀態
  transition("emailInput");
};
</script>
<style scoped>
.backgroundImg {
  height: 100vh;
  width: 100%;
  background-image: linear-gradient(
      149.47deg,
      rgba(39, 39, 39, 0.9) 0.47%,
      rgba(0, 0, 0, 0.9) 81.27%
    ),
    url("@/assets/images/login_background.svg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
